
export {TabManager};

import {e} from './utils.js';
import {TabButton} from './buttons.js';
import {SearchResultsMgr, ProgressBar, state} from './index.js';


// -------------------------
// TAB MANAGER
// -------------------------

function TabManager() {
	// -------------------------
	// Properties
	// -------------------------

	this.bTabs = {};

	if (state.owner || state.playlistonly === 0) {
		if (state.touch) {
			this.bTabs.games = TabButton(120, 30, "ACTIVITIES", e("games_page"), this);
		} else {
			this.bTabs.games = TabButton(120, 30, "GAMES", e("games_page"), this);
		}
		this.bTabs.filter = TabButton(120, 30, "FILTER", e("filter_page"), this);
		this.bTabs.results = TabButton(120, 30, "RESULTS", e("results_page"), this);

		e("tab_bar").appendChild(this.bTabs.games);
		e("tab_bar").appendChild(this.bTabs.filter);
		e("tab_bar").appendChild(this.bTabs.results);
	} else {
		this.bTabs.playlists = TabButton(120, 30, "PLAYLIST", e("playlist_page"), this);
	}

	if (state.owner) {
		this.bTabs.playlists = TabButton(120, 30, "PLAYLISTS", e("playlist_page"), this);
		this.bTabs.setup = TabButton(120, 30, "SETUP", e("setup_page"), this);

		e("tab_bar").appendChild(this.bTabs.playlists);
		e("tab_bar").appendChild(this.bTabs.setup);

		// Setup disabled on mobile due to cluttered editable fields
		$(this.bTabs.setup).addClass('hide-mobile');
	}

	// -------------------------
	// Functions
	// -------------------------

	this.clicked = f_clicked;
	this.show    = f_show;
	this.active  = f_active;


	// -------------------------
	// Methods
	// -------------------------

	function f_clicked(b) {
		if (b == this.bTabs.results) {
			// Show the progress bar
			ProgressBar.show();
			ProgressBar.reset();

			// Do the search and get the tab to display
			b = this.bTabs[SearchResultsMgr.do_search()];

			if (b != this.bTabs.results) {
				ProgressBar.hide();
			}
		} else {
			// Clear the Results table rows and exports
			SearchResultsMgr.clear_table();
			SearchResultsMgr.clear_export();
		}

		// Display proper page
		for (var p in this.bTabs) {
			if (this.bTabs[p] == b) {
				this.bTabs[p].select();
				b.tab_page.style.visibility = "visible";
				b.tab_page.style.display    = "flex";
			} else {
				this.bTabs[p].deselect();
				this.bTabs[p].tab_page.style.visibility = "hidden";
				this.bTabs[p].tab_page.style.display    = "none";
			}
		}
	}

	function f_show(page) {
		this.bTabs[page].onclick();
	}

	function f_active() {
		var active_tab;
		for (var tab in this.bTabs){
			if (this.bTabs[tab].tab_page.style.visibility === "visible"){
				active_tab = this.bTabs[tab].tab_page;
				break;
			}
		}
		return active_tab;
	}
}

